import Publications from './Publications.page';

export default Publications;